<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Facturas en ruta</h3>
          <h6 class="text-muted">del día de hoy</h6>
        </div>
        <!-- <div class="col text-right">
          <a href="#!" class="btn btn-sm btn-primary">See all</a>
        </div> -->
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light" :data="tableData">
        <template slot="columns">
          <th>Factura</th>
          <th>Chofer</th>
          <th>Fecha ruta</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <span style="font-size:15px">{{row.factura}}</span><br>
            <span class="text-muted" style="font-size:10px">{{row.clienteNombre}}</span>
          </th>
          <td>
            {{row.choferNombre}}
          </td>
          <td>
            {{row.timestampRuta | formatDate}}
          </td>
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
  import { getDatabase, ref, onValue } from "firebase/database";

  export default {
    name: 'page-visits-table',
    created() {
      const db = getDatabase();
      const enrutaRef = ref(db, "enruta");
      onValue(enrutaRef, (snapshot) => {
        this.tableData = snapshot.val();
      });
    },
    data() {
      return {
        tableData: []
      }
    }
  }
</script>
<style>
</style>
